export const AUTH_TOKEN = 'auth_token';
export const USER_ROLE = "userRole";
export const USER_INFORMATION = "userInformation";
export const USER_All_INFORMATION = "userAllInformation";
export const EMAIL = 'email';
export const IMPERSONATE = 'impersonate';
export const VERSION = 'appVersion';
export const DASHBOARD_NAV_TREE = "dashBoardNavTree";
export const PROTECTED_ROUTE = "protectedRoutes";
export const DEFAULT_ROUTE = 'default';